<script>
import ChannelMixin from "./channel-mixin"
import ChannelPostMenu from "./channel-post-menu.vue"

export default {
  name: 'TeamChannel',
  mixins: [ChannelMixin],
  components: {ChannelPostMenu},
  props: {
    navRelative: {type: Boolean, default: false},
  },
}
</script>

<template>
<span>
  <div ref="postList" class="c-flex">
    <div v-if="orderedPostIds.length" class="list-group">

      <div v-if="prevPostId" class="list-group-item text-center">
        <span class="btn" @click.prevent="fetchOlderPosts">
          <i class="fas fa-chevron-up"></i>
        </span>
      </div>

      <div v-for="pid in orderedPostIds" :key="pid" class="list-group-item"
      >
        <channel-post-menu
         v-if="posts[pid].showMenu"
         :post="posts[pid]" 
         @like="reactToPost($event, 'heart')"
         @thumbsup="reactToPost($event, '+1')"
         @reply="replyToPost($event)"
         @reply-private="replyPrivateToPost($event)"
         @edit="editPost($event)"
         @delete="deletePost($event)"
        />

        <div class="d-flex">
          <img :src="avatars[posts[pid].user_id]" class="avatar" :alt="avatars[posts[pid].username]" />
          <div class="flex-grow-1 ms-2">
            <div @click="onPostClick(pid, $event)">
              <div>
                <b v-if="users[posts[pid].user_id]">@{{ users[posts[pid].user_id].username }}:</b><span class="text-muted">&nbsp;{{ getFormatedDate(posts[pid].create_at) }}</span>
              </div>
              <div class="c-post" v-html="convert2Html(posts[pid].message)"></div>
            </div>
            <img class="img-thumbnail c-post-img" v-for="image in postImages[pid]" :key="image.src" :src="image.src" :alt="image.name" />
            <div v-if="pid in postReactions">
              <button v-for="(v, k) in postReactions[pid]" :key="k" class="btn btn-sm btn-outline-light me-1"
               @click.prevent="reactToPost(pid, k)"
              >
                <span style="color: black">{{ emojis[k] || k }}&nbsp;{{ v.size }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="error" class="alert alert-danger">
      {{ error }}
    </div>
  </div>
  <div :class="{'c-navbar': navRelative, 'fixed-bottom': !navRelative, 'c-nav-padding': navRelative}">
    <nav class="nav navbar navbar-light bg-light">
      <form style="width:100%">
          <div class="input-group">
              <textarea ref="postInput" class="form-control" 
                v-model="postInput"
                @keydown.shift.enter.prevent="postMessage"
                @keydown.ctrl.enter.prevent="postMessage"
                :rows="currentRows"
              ></textarea>
              <button class="btn" @click.prevent="postMessage">
                  <span class="far fa-paper-plane"></span>
              </button>
          </div>
      </form>
    </nav>
  </div>
</span>
</template>

<style scoped>
.c-navbar {
  flex-shrink: 0; /* Prevents navbar from growing */
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.c-nav-padding {
  padding-left: 15px;
  padding-right: 15px;
}

.c-flex {
  flex: 1;
}
.avatar {
  height:30px;
  width:30px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}
.c-post-img {
  max-height: 40vh
}
</style>